export default {"src":"/_next/static/media/pe.3cf1fd95.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};